// component
import CasIconButton from './CasIconButton';

export default function CasRefreshButton({ refetch }: { refetch: VoidFunction }) {
  return <CasIconButton icon="raphael:acw" onClick={() => refetch()} />;
}
